import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
// Import actions for companies
import {
  getCompanies,
  getSpecificCompany,
  updateCompany,
} from "../../store/AsyncMethods/CompanyMethod";
import { RESET_SPECIFIC_COMPANY } from "../../store/Types/CompanyTypes"; // Assuming you have this type
import { useTranslation } from "react-i18next";
import { getTenants } from "../../store/AsyncMethods/TenantMethod";
export default function EditCompany() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams(); // companyId or id, ensure it matches your route param
  const { t } = useTranslation();
  const { allTenants } = useSelector((state) => state.TenantReducer);

  const { specificCompany } = useSelector((state) => state.CompanyReducer); // Assuming CompanyReducer and specificCompany state

  useEffect(() => {
    if (specificCompany) {
      formik.setValues({
        company_name: specificCompany.company_name || "",
        tenant_id: specificCompany.tenant_id || "", // Ensure tenant_id is handled (string/number)
      });
    }
  }, [specificCompany]);

  const formik = useFormik({
    initialValues: {
      company_name: "",
      tenant_id: "",
    },
    validationSchema: Yup.object({
      company_name: Yup.string().required("Company Name Required"),
      tenant_id: Yup.string().required("Tenant ID Required"), // Or Yup.number() if it's a number
    }),

    onSubmit: async (data) => {
      dispatch(updateCompany(data, id)).then((success) => { // Pass id to updateCompany
        if (success) {
          formik.resetForm();
          dispatch({ type: RESET_SPECIFIC_COMPANY }); // Reset specific company state
          dispatch(getCompanies());
          navigate("/manage-companies");
        }
      });
    },
  });



  useEffect(() => {
    if (id) {
      dispatch(getSpecificCompany(id));
      dispatch(getTenants()); // Fetch specific company on mount
    }
    // return () => {
    //   dispatch({ type: RESET_SPECIFIC_COMPANY }); // Optional: Cleanup on unmount
    // };
  }, [id, dispatch]);

  return (
    <div className="mx-4">
      <div>
        <Button
          label={t("back")}
          icon="pi pi-arrow-left"
          className="p-black-btn"
          onClick={() => {
            dispatch({ type: RESET_SPECIFIC_COMPANY });
            navigate(-1);
          }}
        />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-4">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {t("edit_company")}
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="company_name" className="">
                  {t("company_name")}
                </label>
                <span className=" w-full">
                  <InputText
                    id="company_name"
                    name="company_name"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.company_name}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.company_name && formik.errors?.company_name && (
                <div className="p-error">{formik.errors?.company_name}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="tenant_id" className="">
                  {t("select_tenant")}
                </label>
                <span className="w-full">
                  <Dropdown
                    id="tenant_id"
                    name="tenant_id"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.tenant_id}
                    onChange={formik.handleChange}
                    options={allTenants}
                    optionLabel={(option) => option.first_name + " " + option.last_name + " - [" + option.email + "]"}
                    optionValue="id"
                    // If tenant_id should not be editable or fetched from a list, adjust accordingly
                  />
                </span>
              </div>
              {formik.touched?.tenant_id && formik.errors?.tenant_id && (
                <div className="p-error">{formik.errors?.tenant_id}</div>
              )}
            </div>
          </div>
          <div className="mt-16">
            <div className="flex justify-end gap-4">
              <Button
                label={t("cancel")}
                icon="pi pi-times"
                className="p-red-btn w-28"
                type="button"
                onClick={() => {
                  formik.resetForm();
                  dispatch({ type: RESET_SPECIFIC_COMPANY });
                  navigate("/manage-companies");
                }}
              />
              <Button
                label={t("update")}
                icon="pi pi-check"
                className="p-secondary-btn w-28"
                type="submit"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
} 